import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import axios from 'axios';

const TopLoadingBar = () => {
  const location = useLocation();
  const loadingRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Interceptor dla requestów
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        setIsLoading(true);
        loadingRef.current?.continuousStart();
        return config;
      },
      (error) => {
        setIsLoading(false);
        loadingRef.current?.complete();
        return Promise.reject(error);
      }
    );

    // Interceptor dla odpowiedzi
    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        setIsLoading(false);
        loadingRef.current?.complete();
        return response;
      },
      (error) => {
        setIsLoading(false);
        loadingRef.current?.complete();
        return Promise.reject(error);
      }
    );

    // Cleanup interceptorów
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  // Dodatkowy efekt dla zmiany ścieżki
  useEffect(() => {
    if (!isLoading) {
      loadingRef.current?.continuousStart();
      const timer = setTimeout(() => {
        loadingRef.current?.complete();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location.pathname, isLoading]);

  return (
    <LoadingBar
      color="#1976d2"
      ref={loadingRef}
      height={3}
      shadow={false}
      waitingTime={300}
    />
  );
};

export default TopLoadingBar;